import React, { forwardRef, useImperativeHandle, useRef } from "react";
import NPSAnimatedEmoji from "./NPSAnimatedEmoji";
import "./NPSScoreBadge.css";

// Exposes play() so a container (e.g. a table row) can replay the emoji on
// hover, in addition to hovering/focusing the badge itself.
const NPSScoreBadge = forwardRef(({ score }, ref) => {
  const emojiRef = useRef(null);

  useImperativeHandle(ref, () => ({
    play: () => emojiRef.current?.play(),
  }), []);

  return (
    <span
      className="nps-score-badge"
      onMouseEnter={() => emojiRef.current?.play()}
      onFocus={() => emojiRef.current?.play()}
      tabIndex={-1}
    >
      <NPSAnimatedEmoji ref={emojiRef} score={score} size={26} />
      <span className="nps-score-badge-num">{score}</span>
    </span>
  );
});

export default NPSScoreBadge;
